import React from "react";
import { Toaster } from "./components/ui/toaster";
import { Toaster as Sonner } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Assessment from "./pages/Assessment";
import ForTherapists from "./pages/ForTherapists";
import TherapistMatching from "./pages/TherapistMatching";
import Events from "./pages/Events";
import * as style from './LandingApp.module.css';

const queryClient = new QueryClient();

const LandingApp = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/landing/assessment" element={<Assessment />} />
          <Route path="/landing/therapists" element={<ForTherapists />} />
          <Route path="/therapist-matching" element={<TherapistMatching />} />
          <Route path="/landing/events" element={<Events />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default LandingApp;
